export default __webpack_public_path__ + "static/media/AO.0e5f330f.svg";